import { PREVIEW_MODE } from '../constants';

export const getApiUrl = () => {
    // In Preview Mode and Development Environment, use the absolute FUNNEL_API URL from environment variables
    // In the Live Funnel we can use the relative path on the Funnel domain
    const apiUrl =
        PREVIEW_MODE || import.meta.env.DEV
            ? import.meta.env.VITE_FUNNEL_API ||
              'https://payments-api.perspective-dns.com/ps-payments/api'
            : '/ps-payments/api';

    return apiUrl;
};
